import * as React from "react";
import { Component } from "react";
import "./FormGroup.css";
import { Input } from "./Input";
import { Label as LabelComponent } from './Label'

interface IProps {
    Flex?: string;
    Label?: string | JSX.Element;
    CustomLabel?: JSX.Element;
    Name?: string;
    Type?: string;
    OnChange?: (evt) => void;
    Value?: string | number;
    Disabled?: boolean;
    WarningBlock?: string;
    ErrorBlock?: string;
    HelpBlock?: string;
    ValidationState?: () => "success" | "warning" | "error" | undefined;
    ClassName?: string;
    OnBlur?: (evt) => void;
    Placeholder?: string;
    Optional?: boolean;
    OptionalShort?: boolean;
    LabelSide?: boolean;
}

export class FormGroup extends Component<IProps, any> {
    constructor(props) {
        super(props);
    }

    public render() {
        const { children = "", ClassName = "", Label, Optional = false, OptionalShort = false, CustomLabel, LabelSide } = this.props;

        return (
            <div
                className={`form-group ${ClassName}`}
            >
                {LabelSide ?
                    <div className="form-group--label-side">
                        {Label &&
                            <LabelComponent
                                optional={Optional}
                                optionalShort={OptionalShort}>
                                {Label}
                            </LabelComponent>
                        }
                        {CustomLabel && CustomLabel}
                        <div className="form-group__wrapper">
                            {children ? children : this.RenderInput()}
                            {this.RenderHelpBlock()}
                            {this.RenderWarningBlock()}
                            {this.RenderErrorBlock()}
                        </div>
                    </div>
                    :
                    <>
                        {Label &&
                            <LabelComponent
                                optional={Optional}
                                optionalShort={OptionalShort}>
                                {Label}
                            </LabelComponent>
                        }
                        {CustomLabel && CustomLabel}
                        {children ? children : this.RenderInput()}
                        {this.RenderHelpBlock()}
                        {this.RenderWarningBlock()}
                        {this.RenderErrorBlock()}
                    </>
                }

            </div>
        );
    }

    private RenderInput = () => {
        const {
            Type = "text",
            Name,
            Value,
            Disabled,
            Placeholder,
            ValidationState
        } = this.props;

        let errorClass = "";

        if (ValidationState && ValidationState() === "error") {
            errorClass = "form-control--has-error";
        }

        return (
            <Input
                ClassName={"form-control " + errorClass}
                Type={Type}
                Name={Name}
                Value={Value}
                OnChange={this.OnInputChange}
                OnBlur={this.OnBlur}
                Disabled={Disabled}
                Placeholder={Placeholder}
            />
        );
    }

    private RenderHelpBlock = () => {
        const { HelpBlock, ValidationState } = this.props;
        if (
            !HelpBlock ||
            !ValidationState ||
            (ValidationState && ValidationState() !== undefined)
        ) {
            return null;
        }

        return <span className="help-block help-block--help-block">{HelpBlock}</span>;
    }

    private RenderWarningBlock = () => {
        const { WarningBlock, ValidationState } = this.props;

        if (!WarningBlock || !ValidationState || (ValidationState && ValidationState() !== "warning")) {
            return null;
        }

        return <span className="help-block help-block--warning-block">{WarningBlock}</span>;
    }

    private RenderErrorBlock = () => {
        const { ErrorBlock, ValidationState } = this.props;

        if (!ErrorBlock || !ValidationState || (ValidationState && ValidationState() !== "error")) {
            return <span className="help-block help-block--error-block help-block--hidden">{ErrorBlock ? ErrorBlock : "xx"}</span>;
        }

        return <span className="help-block help-block--error-block">{ErrorBlock}</span>;
    }

    private OnInputChange = (evt) => {
        if (this.props.OnChange) {
            this.props.OnChange(evt);
        }
    }

    private OnBlur = (evt) => {
        if (this.props.OnBlur) {
            this.props.OnBlur(evt);
        }
    }
}



// WEBPACK FOOTER //
// ./src/controls/Form/FormGroup.tsx